module.exports = __webpack_public_path__ + "static/media/details-3.4c465aa0.jpeg";